import gql from "graphql-tag";

export default gql(`
query listAnswers($id:String!){
  listAnswers(limit:1000, filter: { authorId: {eq: $id}}){
    items{
      id
    }
  }
}`);